import { reduceFeaturesResponse, reduceFeaturesWithDefaultsResponse } from 'pricing-pages-lib/reducers/Features';
import { FetchFeaturesRequestTypes, FetchFeaturesRequestTypesCMS, FetchFeaturesRequestTypesMARKETING, FetchFeaturesRequestTypesOPERATIONS, FetchFeaturesRequestTypesSALES, FetchFeaturesRequestTypesSERVICE, FetchFeaturesWithDefaultsRequestTypes } from '../actions/FeatureActions';
const initialState = {
  features: {},
  highlightedProducts: {},
  defaults: {}
};
const Features = (state = initialState, {
  type,
  payload
}) => {
  switch (type) {
    case FetchFeaturesRequestTypes.RECEIVE:
    case FetchFeaturesRequestTypesMARKETING.RECEIVE:
    case FetchFeaturesRequestTypesSALES.RECEIVE:
    case FetchFeaturesRequestTypesSERVICE.RECEIVE:
    case FetchFeaturesRequestTypesCMS.RECEIVE:
    case FetchFeaturesRequestTypesOPERATIONS.RECEIVE:
      {
        if (payload && 'props' in payload && payload.props) {
          const data = payload.data;
          const productLine = payload.props.productLine;
          const highlightedProducts = payload.props.highlightedProducts;
          if (data && productLine && highlightedProducts) {
            return reduceFeaturesResponse({
              data,
              productLine,
              highlightedProducts,
              state: state
            });
          }
        }
        return state;
      }
    case FetchFeaturesWithDefaultsRequestTypes.RECEIVE:
      {
        if (payload && !payload.props) {
          const data = payload.data;
          if (data) {
            return reduceFeaturesWithDefaultsResponse({
              data,
              state: state
            });
          }
        }
        return state;
      }
    default:
      return state;
  }
};
export default Features;